import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import img$3 from '../../assets/amex@2x.png.js';
import img$6 from '../../assets/bancontact_logo.png.js';
import img$5 from '../../assets/cartebancaire@2x.png.js';
import img$2 from '../../assets/diners@2x.png.js';
import img$4 from '../../assets/maestro@2x.png.js';
import img$1 from '../../assets/mc@2x.png.js';
import img from '../../assets/visa@2x.png.js';
import { handleKeyDown } from '../../utils/utils.js';
import styles from './CardIcon.module.scss.js';

const IMAGES = {
    visa: img,
    mastercard: img$1,
    'diners-club': img$2,
    'american-express': img$3,
    maestro: img$4,
    discover: undefined,
    jcb: undefined,
    unionpay: undefined,
    elo: undefined,
    mir: undefined,
    hiper: undefined,
    hipercard: undefined,
    cartebancaire: img$5,
    cartebancontact: img$6,
};
const CardIcon = ({ className, clickable, onClick, type, subtle }) => {
    const image = type ? IMAGES[type] : null;
    const alt = type ? type : '';
    return image ? (jsx("img", { alt: alt, className: classNames(styles.cardIcon, clickable && styles.clickable, subtle && styles.subtle, className), "data-zta": "ccImage", onClick: onClick, onKeyDown: (e) => handleKeyDown(e, onClick), tabIndex: clickable ? 0 : -1, src: image })) : null;
};

export { CardIcon as default };
//# sourceMappingURL=CardIcon.js.map
